export const fmt = (n: number, d = 3) =>
  isNaN(n) || !isFinite(n) ? "—" : n.toFixed(d).replace(/\.?0+$/, "") || "0";

export const ANGLE_PRESETS: { label: string; deg: number }[] = [
  { label: "11.25°", deg: 11.25 },
  { label: "22.5°", deg: 22.5 },
  { label: "30°", deg: 30 },
  { label: "45°", deg: 45 },
  { label: "60°", deg: 60 },
  { label: "90°", deg: 90 },
];

export const ResultCard = ({ label, value, unit, accent }: { label: string; value: string; unit: string; accent?: boolean }) => (
  <div className="trade-card flex justify-between items-center">
    <span className="text-sm text-muted-foreground">{label}</span>
    <span className={`font-mono-data text-lg font-bold ${accent ? "text-primary" : "text-foreground"}`}>
      {value} {unit && <span className="text-xs text-muted-foreground font-normal">{unit}</span>}
    </span>
  </div>
);
